export class CatalogoRequest {
     authorId : string;
     categoryId :  string;
     categoryName: string;
     page :  string;
     publicationId :  string;
     subCategoryId: string;
     subCategoryName:string;
     size :  string;
     title :   string;
     yearId :  string;
     constructor(){
        this.authorId = "0";
        this.categoryId =  "0";
        this.page =  "0";
        this.subCategoryId = "0";
        this.publicationId =  "0";
        this.size =  "0";
        this.title =   "";
        this.yearId =  "0";
        this.categoryName = "";
        this.subCategoryName = "";
     }
}
